import React from 'react';

const NotFound = () => {
  return <h3>Page not found</h3>;
};

export default React.memo(NotFound);
